import jsonLogic from 'json-logic-js';

jsonLogic.add_operation(
  'containsValue',
  (targetArr: string[], search: string) => targetArr && targetArr.includes(search)
);

jsonLogic.add_operation(
  'containsAny',
  (targetArr: string[], searchForArr: string[]) =>
    targetArr && searchForArr.some(r => targetArr.includes(r))
);

jsonLogic.add_operation(
  'containsAll',
  (targetArr: string[], searchForArr: string[]) =>
    targetArr && searchForArr.every(r => targetArr.includes(r))
);

jsonLogic.add_operation('startsWith', (str: string, search: string) =>
  str ? str.startsWith(search) : false
);
jsonLogic.add_operation('endsWith', (str: string, search: string) =>
  str ? str.endsWith(search) : false
);

jsonLogic.add_operation('search', (str: string, search: string) =>
  str && search ? str.toLowerCase().includes(search.toLowerCase()) : false
);

type WithRule = {
  rule: string;
};

type WithAttributes = {
  attributes?: Record<string, any>;
};

const attributeNameConversion = <T extends WithAttributes>(item: T) => {
  const convertedAttributes = {} as Record<string, any>;

  if (!item.attributes) return item;

  Object.entries(item.attributes).forEach(([key, value]) => {
    convertedAttributes[key.split('.').join('##')] = value;
  });

  return { ...item, attributes: convertedAttributes };
};

const applyJsonLogic = <T extends {}>(item: T, filters: WithRule[]) => {
  return filters.filter(({ rule }) => jsonLogic.apply(rule, attributeNameConversion<T>(item)));
};

export default applyJsonLogic;
